import type { ChangeEvent } from 'react';
import { useContext, useMemo, useState } from 'react';

import { useDebounce } from 'src/hooks';
import { AccordionContext } from 'src/components/common/Accordion';
import { CREATE_FOLLOW_UP_MODAL_ACCORDION_NAMES } from 'src/components/myFollowUp/MyFollowUpPage/CreateMyFollowUpModal/constants';
import { useCreateActionItemContext } from 'src/components/myFollowUp/MyFollowUpPage/CreateMyFollowUpModal/CreateActionItemContext';

import { usePotentialFollowUpOwners } from './usePotentialFollowUpOwners';

export const useSelectOwner = () => {
  const { toggleActiveState } = useContext(AccordionContext);
  const { followUpOwner, setFollowUpOwner, selectedOrgUnits } =
    useCreateActionItemContext();
  const [searchString, setSearchString] = useState('');
  const debouncedSearch = useDebounce(searchString, 500);
  const {
    data: followUpOwners,
    isLoading,
    isFetching,
    error,
  } = usePotentialFollowUpOwners({
    search: debouncedSearch,
    orgUnitIds: selectedOrgUnits.map(({ id }) => id),
  });

  const selectedOwnerName = useMemo(() => {
    const selected = followUpOwners?.results?.find(
      (owner) => owner.id === followUpOwner?.id,
    );
    return selected ? selected.fullName : '';
  }, [followUpOwners, followUpOwner]);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchString(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchString('');
  };

  const handleOwnerSelect = (event: ChangeEvent<HTMLInputElement>) => {
    setFollowUpOwner(
      followUpOwners?.results?.find(
        (owner) => owner.id === Number(event.target.value),
      ),
    );
    toggleActiveState(CREATE_FOLLOW_UP_MODAL_ACCORDION_NAMES.OWNER);
  };
  return {
    followUpOwners,
    searchString,
    selectedOwnerName,
    handleOwnerSelect,
    handleSearchChange,
    handleClearSearch,
    isLoading,
    isFetching,
    error,
  };
};
